// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slot__container[data-v-2adff5e8] {\n  min-width: 1.25rem;\n}", ""]);
// Exports
module.exports = exports;
